import { useEffect, useState, useCallback } from "react";
import { useIsAdmin } from "./useIsAdmin";

// Глобальное (на время работы вкладки) состояние в модуле:
let _adminMode = false;
const subscribers = new Set();

function setGlobal(next) {
  _adminMode = !!next;
  subscribers.forEach(fn => fn(_adminMode));
}

export const useAdminMode = () => {
  const { isAdmin, loading } = useIsAdmin();
  const [adminMode, setAdminMode] = useState(_adminMode);

  // подписываемся на изменения из других компонентов
  useEffect(() => {
    subscribers.add(setAdminMode);
    // синхронизируемся на случай «горячей» загрузки компонента
    setAdminMode(_adminMode);
    return () => subscribers.delete(setAdminMode);
  }, []);

  const enableAdmin  = useCallback(() => { if (isAdmin) setGlobal(true); }, [isAdmin]);
  const disableAdmin = useCallback(() => setGlobal(false), []);
  const toggleAdmin  = useCallback(() => setGlobal(!_adminMode), []);

  return { adminMode, enableAdmin, disableAdmin, toggleAdmin, isAdmin, loading };
};
